import { Avatar, Box, Tooltip, Typography } from "@mui/material";
import { APP_NAME } from "../../utils/app-info";

type Props = {};

// Compact brand header for the sidebar — was a 150x150 centered avatar with
// no app name, eating most of the sidebar's visible height before a single
// nav link was reached.
const AppLogo = (props: Props) => {
  return (
    <Tooltip title={process.env.REACT_APP_VERSION} enterDelay={1000}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.25,
          paddingInline: 2,
          paddingBlock: 2.5,
        }}
      >
        <Avatar
          sx={{ width: 40, height: 40, bgcolor: "primary.main" }}
          variant="rounded"
          src="/images/logo.svg"
          alt="company logo"
        />
        <Typography variant="h6" noWrap>
          {APP_NAME}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default AppLogo;
